import { Button, Col, Row, Typography } from 'antd'
import React from 'react'
import { storageKeys } from '../../../Constants'
import { handleMyTax } from '../../../helper'
import './SelfEmployedStatus.css'
import PersistentCooldownButton from './PersistentCooldownButton'

const { Title } = Typography

export default function InActiveSelfEmployedStatus ({ onClick, loading }) {
  const handleClick = () => {
    onClick?.()
  }
  return (
    <Row justify='space-between' className='selfEmployedStatus'>
      <Col span={24} className='info-block'>
        <Row>
          <Col span={24}>
            <Title level={3}>Остался последний шаг</Title>
            <p>Подключите партнёрство в "Мой налог"</p>
            <p>
              Мы отправили вам запрос на партнёрство в "Мой налог"
            </p>
            <p>
              Важно выбрать Купер в качестве партнёра, чтобы получать выплаты и автоматически учитывать доходы
            </p>
            <ul>
              <li>Откройте "Мой налог" — сайт или приложение</li>
              <li>Перейдите в меню, раздел "Партнёры"</li>
              <li>Нажмите "Разрешить" в появившемся запросе от Купера</li>
              <li>Вернитесь на этот экран и нажмите "Готово"</li>
            </ul>
            <p>Если возникнут сложности, звоните: 8 800 250 54 50</p>
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <img src='/img/pencil.png' className='pencil' />
          </Col>
        </Row>
      </Col>
      <Col span={24} className='btn-block'>
        <Button
          className='btn-my-tax'
          size='large'
          block
          onClick={handleMyTax}
        >
          <img src='/img/fns.png' className='mr-3' />Перейти в «Мой налог»
        </Button>
        {/* <Button
          ghost
          block
          size='large'
          type='primary'
          className='margin-top-20 margin-bottom-20'
          onClick={handleClick}
          loading={loading}
        >
          Подтвердить партнёрство
        </Button> */}
        <PersistentCooldownButton
          text='Готово'
          storageKey={storageKeys.cooldownBtnLastStepPartner}
          size='large'
          type='primary'
          className='margin-top-20 margin-bottom-20 ant-btn-background-ghost'
          loading={loading}
          onClick={handleClick}
        />
      </Col>
    </Row>
  )
}
